import { render, staticRenderFns } from "./PhoneSelector.vue?vue&type=template&id=c747c7ac&scoped=true"
import script from "./PhoneSelector.vue?vue&type=script&lang=js"
export * from "./PhoneSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c747c7ac",
  null
  
)

export default component.exports